import React from "react";
import { Modal } from "../../../design-system/components/composite/Modal/Modal";
import { TenantSelectForm } from "../TenantSelectForm";
import { ModalBody, ModalDescription, ModalTitle } from "./SwitchTenantModal.styles";
import type { SwitchTenantModalProps } from "./SwitchTenantModal.types";
import { useSwitchTenantModalInternalState } from "./useSwitchTenantModalInternalState";

/**
 * "Switch organization" dialog opened from the sidebar profile menu. Reuses the
 * login flow's `TenantSelectForm` unchanged apart from labels and a preselected
 * current tenant.
 */
export const SwitchTenantModal: React.FC<SwitchTenantModalProps> = ({
  open,
  onClose,
  currentTenantId,
  onUnauthorized,
}) => {
  const { handleContinue } = useSwitchTenantModalInternalState({ onClose });

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="md"
      zIndex={1400}
      ariaLabelledBy="switch-tenant-title"
    >
      <ModalBody>
        <ModalTitle id="switch-tenant-title">Switch organization</ModalTitle>
        <ModalDescription>
          Choose the organization you want to work in.
        </ModalDescription>
        <TenantSelectForm
          initialTenantId={currentTenantId}
          continueLabel="Switch organization"
          backLabel="Cancel"
          onBack={onClose}
          onContinue={handleContinue}
          onUnauthorized={onUnauthorized}
        />
      </ModalBody>
    </Modal>
  );
};

export default SwitchTenantModal;
